import type Swiper from "swiper";
import TabindexSwitch from "../objects/tabindex-switch";

export const swiperSliderTabindexFix = (swiper: Swiper) => {
  const maxSlidesCount = swiper.slides.length;
  const tabindexSwitches = swiper.slides.map(
    (slideElement) => {
      const tabindexSwitch = new TabindexSwitch(slideElement);
      tabindexSwitch.disableTabindex();
      return tabindexSwitch;
    }
  );

  disableAllSlidesTabindex();
  enableVisibleSlidesTabindex(swiper);

  swiper.on("slideChangeTransitionStart", disableAllSlidesTabindex);
  swiper.on("slideChangeTransitionEnd", enableVisibleSlidesTabindex);

  function disableAllSlidesTabindex() {
    tabindexSwitches.forEach((tabindexSwitch) => tabindexSwitch.disableTabindex());
  }

  function enableVisibleSlidesTabindex(swiper: Swiper) {
    const visibleSlidesCount = swiper.slidesPerViewDynamic();
    const activeSlideIndex = swiper.realIndex;
    const indexArray: number[] = [];
    let indexCount = 0;

    while (indexCount < visibleSlidesCount) {
      let currentIndex = activeSlideIndex + indexCount;

      if (currentIndex >= maxSlidesCount) {
        currentIndex = currentIndex - maxSlidesCount;
      }

      indexArray.push(currentIndex);
      indexCount++;
    }

    indexArray.forEach((index) => {
      tabindexSwitches[index].enableTabindex();
    });
  }
};
